import { useDeleteProfileLink } from '@lopo-tech/lopo-api'
import React, { FunctionComponent, useCallback } from 'react'
import { textResources } from '../../../lang/de'
import Icon, { IconSize } from '../../forms/icon/icon'
import './remove_link.scss'

const sharedLabels = textResources.shared

interface RemoveLinkProps {
  linkId: string | undefined;
  onDelete: () => void;
  size?: IconSize;
}

const RemoveLink: FunctionComponent<RemoveLinkProps> = ({ linkId, onDelete, size }) => {
  const [deleteProfileLink] = useDeleteProfileLink()

  const onClick = useCallback(async () => {
    if (!linkId) return

    await deleteProfileLink({ variables: { input: { id: linkId } } })
    onDelete()
  }, [])

  return linkId
    ? (
      <div onClick={onClick} className={'remove-link'}>
        <span className={'remove-link__title'}>{sharedLabels.delete}</span>
        <Icon name={'delete'} size={size} description={sharedLabels.delete} />
      </div>
    )
    : null
}

export default RemoveLink
